<style scoped>

</style>
<template>
  <div>
    <h2 class="text-center">
      超有爱集团银行账户
    </h2>
    <div class="line text-center">
      <Button
        type="primary"
        icon="md-add"
        @click="editBank(new_bank)"
      >
        添加银行
      </Button>
      <space />
      <Select
        v-model="params.company_id"
        clearable
        placeholder="选择公司"
        style="width: 110px"
        @on-change="getBanks"
      >
        <Option
          v-for="company in companies"
          :key="company.id"
          :value="company.id"
        >
          {{ company.short_name }}
        </Option>
      </Select>
      <space />
      <Select
        v-model="params.settle_type"
        clearable
        placeholder="结算方式"
        style="width: 110px"
        @on-change="getBanks"
      >
        <Option
          v-for="type in settle_types"
          :key="type.value"
          :value="type.value"
        >
          {{ type.label }}
        </Option>
      </Select>
      <space />
      <i-input
        v-model="params.search"
        clearable
        placeholder="关键字搜索..."
        style="width: 180px"
        @on-enter="getBanks"
        @on-clear="getBanks"
      />
      <space />
      <Button
        type="primary"
        icon="md-search"
        :loading="loading"
        @click="getBanks"
      >
        搜索
      </Button>
    </div>
    <div class="line">
      <Table
        size="small"
        :columns="bank_columns"
        :data="banks"
        :loading="loading"
      />
    </div>

    <Modal
      v-model="edit_bank_modal"
      :mask-closable="false"
      width="800"
      title="添加银行"
      :loading="update_bank_loading"
      @on-ok="UpdatedBankOk"
    >
      <div class="line">
        <Form
          ref="editBankEditor"
          :model="edit_bank"
          :label-width="180"
        >
          <FormItem
            v-if="edit_bank.id"
            label="废弃"
          >
            <Checkbox v-model="edit_bank.del">
              是否废弃
            </Checkbox>
          </FormItem>
          <FormItem
            label="结算方式"
            prop="kingdee_settle_type"
            :rules="{ required: true, message: '请选择结算方式' }"
          >
            <Select
              v-model="edit_bank.kingdee_settle_type"
              placeholder="请输入"
            >
              <Option
                v-for="type in settle_types"
                :key="type.value"
                :value="type.value"
              >
                {{ type.label }}
              </Option>
            </Select>
          </FormItem>
          <FormItem
            label="付款对应财务单据"
            prop="payment_fin_bill_kind"
            :rules="{required: true, message: '请设置付款对应财务单据'}"
          >
            <Select
              v-model="edit_bank.payment_fin_bill_kind"
              placeholder="请选择"
            >
              <Option
                v-for="kind in fin_bill_kinds"
                :key="kind.value"
                :value="kind.value"
              >
                {{ kind.label }}
              </Option>
            </Select>
          </FormItem>
          <FormItem
            label="币别"
            prop="currency_id"
            :rules="{type: 'number', required: true, min: 1, message: '请选择币别'}"
          >
            <Select v-model="edit_bank.currency_id">
              <Option
                v-for="currency in currencies"
                :key="currency.id"
                :value="currency.id"
              >
                {{ currency.name }}
              </Option>
            </Select>
          </FormItem>
          <FormItem
            label="所属公司"
            prop="company_id"
            :rules="{type: 'number', required: true, min: 1, message: '请选择公司'}"
          >
            <Select v-model="edit_bank.company_id">
              <Option
                v-for="company in companies"
                :key="company.id"
                :value="company.id"
              >
                {{ company.short_name }}
              </Option>
            </Select>
          </FormItem>
          <FormItem
            label="银行"
            prop="bank"
            :rules="{ required: true, message: '银行不能为空' }"
          >
            <i-input
              v-model="edit_bank.bank"
              placeholder="请输入"
            />
          </FormItem>
          <FormItem label="CBS">
            <Checkbox v-model="edit_bank.is_cbs">
              勾选后，单据将自动通过CBS付款
            </Checkbox>
          </FormItem>
          <FormItem
            label="账户名称"
            prop="account"
            :rules="{ required: true, message: '账户名称不能为空' }"
          >
            <i-input
              v-model="edit_bank.account"
              placeholder="请输入"
            />
          </FormItem>
          <FormItem
            label="银行卡号"
            prop="bank_number"
            :rules="{ required: true, message: '卡号不能为空' }"
          >
            <i-input
              v-model="edit_bank.bank_number"
              placeholder="请输入"
            />
          </FormItem>
          <FormItem
            label="开户行"
            prop="bank_branch"
          >
            <i-input
              v-model="edit_bank.bank_branch"
              placeholder="请输入"
            />
          </FormItem>
          <FormItem
            label="备注"
            prop="desc"
          >
            <i-input
              v-model="edit_bank.desc"
              type="textarea"
              placeholder="请输入"
            />
          </FormItem>
          <div v-if="is_edit_yunzhanghu">
            <div class="hr" />
            <div class="text-center text-large">
              云账户接口信息
            </div>
            <FormItem
              label="云账户账号结算类型"
              prop="yzh_dealer_type"
              :rules="{ required: true, message: '请选择云账户账号结算类型' }"
            >
              <Select v-model="edit_bank.yzh_dealer_type">
                <Option value="per_time">
                  次结
                </Option>
                <Option value="month">
                  月结
                </Option>
              </Select>
            </FormItem>
            <FormItem
              label="云账户商户代码(dealer_id)"
              prop="yzh_dealer_id"
              :rules="{ required: true, message: '请填写云账户商户代码' }"
            >
              <i-input
                v-model="edit_bank.yzh_dealer_id"
                placeholder="请输入"
              />
            </FormItem>
            <FormItem
              label="云账户代征主体(broker_id)"
              prop="yzh_broker_id"
              :rules="{ required: true, message: '请填写云账户代征主体' }"
            >
              <i-input
                v-model="edit_bank.yzh_broker_id"
                placeholder="请输入"
              />
            </FormItem>
            <FormItem
              label="云账户App Key"
              prop="yzh_app_key"
              :rules="{ required: true, message: '请填写云账户App Key' }"
            >
              <i-input
                v-model="edit_bank.yzh_app_key"
                placeholder="请输入"
              />
            </FormItem>
            <FormItem
              label="云账户3DES Key"
              prop="yzh_des_key"
              :rules="{ required: true, message: '请填写云账户3DES Key' }"
            >
              <i-input
                v-model="edit_bank.yzh_des_key"
                placeholder="请输入"
              />
            </FormItem>
          </div>
        </Form>
      </div>
    </Modal>
  </div>
</template>
<script>
  import Util from '../../../libs/util';
  import {mapGetters} from "vuex";
  export default {
    data() {
      return {
        params: {
          search: '',
          company_id: '',
          settle_type: ''
        },
        loading: false,
        banks: [],
        bank_columns: [
          {
            title: '展开',
            type: 'expand',
            align: 'center',
            width: 40,
            render: (h, params) => {
              const row = params.row;
              if (row.kingdee_settle_type === '09') {
                const items = [
                  h('div', `云账户账号结算类型: ${this.getYunzhanghuDealerType(row.yzh_dealer_type)}`),
                  h('div', `云账户商户代码(dealer_id): ${row.yzh_dealer_id}`),
                  h('div', `云账户代征主体(broker_id): ${row.yzh_broker_id}`),
                  h('div', `云账户App Key: ${row.yzh_app_key}`),
                  h('div', `云账户3DES Key: ${row.yzh_des_key}`),
                ];
                return h('div', items);
              }
              return h('div', '-');
            }
          },
          {
            title: '所属公司',
            align: 'center',
            width: 60,
            render: (h, params) => {
              const row = params.row;
              const company = this.companies_hash[row.company_id];
              if (company) {
                return h('div', company.short_name);
              } else {
                return h('div', {
                  'class': {
                    'color-error': true
                  }
                }, '未设置');
              }
            }
          },
          {
            title: '结算方式',
            align: 'center',
            width: 60,
            render: (h, params) => {
              const row = params.row;
              const type = this.settle_types_hash[row.kingdee_settle_type];
              if (type) {
                return h('div', type);
              } else {
                return h('div', {
                  'class': {
                    'color-error': true
                  }
                }, '未设置');
              }
            }
          },
          {
            title: '币别',
            align: 'center',
            width: 60,
            render: (h, params) => {
              const row = params.row;
              const currency = this.currencies_hash[row.currency_id];
              if (currency) {
                return h('div', currency.name);
              } else {
                return h('div', {
                  'class': {
                    'color-error': true
                  }
                }, '未设置');
              }
            }
          },
          {
            title: '银行',
            key: 'bank',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const row = params.row;
              if (row.del) {
                return h('div', {
                  'class': {
                    'color-grey': true
                  }
                }, `${row.bank}(废弃)`)
              } else {
                return h('span', row.bank);
              }
            }
          },
          {
            title: '账户名称',
            key: 'account',
            tooltip: true,
            render: (h, params) => {
              const row = params.row;
              return h('div', {
                'class': {
                  'color-grey': row.del
                }
              }, row.account)
            }
          },
          {
            title: '卡号',
            key: 'bank_number',
            render: (h, params) => {
              const row = params.row;
              const ret = [
                h('span', {
                  'class': {
                    'color-grey': row.del
                  }
                }, row.bank_number)
              ];
              if (row.is_cbs) {
                ret.push(h('Tag', {
                  props: { color: 'success' }
                }, 'CBS'))
              }
              return h('div', ret);
            }
          },
          {
            title: '开户行',
            key: 'bank_branch',
            tooltip: true
          },
          {
            title: '付款对应财务单据',
            width: 130,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const kind = row.payment_fin_bill_kind;
              if (kind) {
                const kind_obj = this.fin_bill_kinds_hash[kind];
                return <span>{ kind_obj ? kind_obj.label : '未定义单据类型' }</span>
              } else {
                return <span class="color-error">请设置</span>;
              }
            }
          },
          {
            title: '备注',
            key: 'desc',
            tooltip: true
          },
          {
            title: '操作',
            align: 'center',
            width: 80,
            render: (h, params) => {
              const ret = [];
              ret.push(h('Button', {
                props: {
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.editBank(params.row);
                  }
                }
              }, '编辑'));
              return h('div', ret);
            }
          }
        ],
        edit_bank_modal: false,
        update_bank_loading: true,
        new_bank: {
          company_id: 0,
          currency_id: 0,
          kingdee_settle_type: '',
          bank: '',
          account: '',
          bank_branch: '',
          bank_number: '',
          payment_fin_bill_kind: '',
          is_cbs: false,
          yzh_dealer_type: '',
          yzh_dealer_id: '',
          yzh_broker_id: '',
          yzh_app_key: '',
          yzh_des_key: '',
          desc: ''
        },
        settle_types: [
          {value: '01', label: '现金'},
          {value: '02', label: '银行'},
          {value: '03', label: '支付宝'},
          {value: '04', label: '微信'},
          {value: '09', label: '云账户'},
          {value: '10', label: '51社保'},
          {value: '11', label: '商务信用卡'},
          {value: '00', label: '其他'},
        ],
        settle_types_hash: {
          '01': '现金',
          '02': '银行',
          '03': '支付宝',
          '04': '微信',
          '09': '云账户',
          '10': '51社保',
          '11': '商务信用卡',
          '00': '其他'
        },
        edit_bank: {},
      }
    },
    computed: {
      ...mapGetters('async', [
        'companies',
        'companies_hash',
        'currencies',
        'currencies_hash',
        'fin_bill_kinds',
        'fin_bill_kinds_hash'
      ]),
      is_edit_yunzhanghu() {
        return this.edit_bank.kingdee_settle_type === '09';
      },
    },
    created() {
      this.getBanks();
    },
    mounted() {
      //
    },
    methods: {
      getYunzhanghuDealerType(yzh_dealer_type) {
        let type;
        switch (yzh_dealer_type) {
        case 'per_time':
          type = '次结';
          break;
        case 'month':
          type = '月结';
          break;
        default:
          type = '未设置';
          break;
        }
        return type;
      },
      getBanks() {
        this.loading = true;
        this.$util.ajax.get(this.$util.api.query_expense_payment_banks, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.banks = [];
          if (res.code === 1) {
            const data = res.data;
            this.banks = data.banks;
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
      editBank(bank) {
        this.edit_bank = Util.clone(bank);
        this.edit_bank_modal = true;
      },
      UpdatedBankOk() {
        this.$refs.editBankEditor.validate((valid) => {
          if (valid) {
            if (!this.processing) {
              this.processing = true;
              Util.ajax.post(Util.api.update_expense_payment_bank, this.edit_bank).then((response) => {
                return response.data;
              }).then((res) => {
                this.processing = false;
                this.update_bank_loading = false;
                this.edit_bank_modal = false;
                setTimeout(() => {
                  this.update_bank_loading = true;
                }, 500);
                if (res.code === 1) {
                  const data = res.data;
                  Util.insertOrUpdateArrayItem(this.banks, data);
                } else {
                  this.$Modal.error({
                    title: '错误',
                    content: res.msg
                  });
                }
              }).catch((e) => {
                this.processing = false;
                this.update_bank_loading = false;
                setTimeout(() => {
                  this.update_bank_loading = true;
                }, 500);
                console.log(e);
              });
            }
          } else {
            this.update_bank_loading = false;
            setTimeout(() => {
              this.update_bank_loading = true;
            }, 500);
            this.$Message.error('请正确填写表单!');
          }
        });
      }
    }
  }
</script>
